import { FC } from "react";

type Severity = "Critical" | "High" | "Medium" | "Low" | "N/A";

type SeverityBadgeProps = {
  severity: Severity;
};

const severityBgColor: Record<Severity, string> = {
  Critical: "bg-semantic-alert-critical",
  High: "bg-semantic-alert-high",
  Medium: "bg-semantic-alert-medium",
  Low: "bg-semantic-alert-low",
  "N/A": "bg-background",
};

export const SeverityBadge: FC<SeverityBadgeProps> = ({ severity }) => {
  return (
    <span
      className={`text-swdc-black-600 flex justify-center px-6 py-3.5 ${severityBgColor[severity]}`}
    >
      {severity}
    </span>
  );
};

export const getSeverityFromCategories = (
  categorization?: {
    parameterName: string;
    categories: string[];
  }[],
): Severity => {
  const categories = categorization?.find(
    (c) => c.parameterName === "severity",
  )?.categories;
  const value = categories?.[0] ?? "N/A";

  if (
    value === "Critical" ||
    value === "High" ||
    value === "Medium" ||
    value === "Low"
  ) {
    return value;
  }

  return "N/A";
};
